<template>
  <q-btn
      v-bind="$attrs"
      dense
      color="white"
      text-color="black"
      :aria-label="tooltip"
  >
    <q-tooltip anchor="top middle" self="bottom middle">
      {{ tooltip }}
    </q-tooltip>
    <slot />
  </q-btn>
</template>

<script>

export default {
  props: {
    tooltip: {
      type: String,
      required: true,
    },
  },
}
</script>
